import Tabs from '../../js/src/tabs.js';

(function ($) {
    if($('[block-name="tabs"]').length){
        $('[block-name="tabs"]').each(function(index,block){
            // Set tab element
            let tab = '.tab-group .tab-group__item';

            if($(block).find(tab).length){
                // Initialize tabs
                let tabs = new Tabs($(block), $(block).find(tab));
            }
        });
    }
})(jQuery);